import axios from "axios";
import Config from "config";
import urljoin from "helpers/urljoin";

const getReferralData = async (userId: string, overrideParams = {}) => {
  const url = urljoin(Config.API_URL, `api/v0/auth/users/${userId}/referrals`);
  const params = {
    methods: "user_referral_details",
    cache: "false",
    ...overrideParams,
  };

  try {
    const response = await axios.get(url, { params, withCredentials: true });
    return response.data;
  } catch (error) {
    console.error("Error fetching referral data:", error);
    throw error;
  }
};

export default getReferralData;
